import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionArray } from "../../../adapters/delegacionAdapter";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import moment from "moment";

const storageId = sessionStorage.getItem('idUsuario');

export const useGetFilters = () => {

  const [delegacionOrigen, setDelegacionOrigen] = useState('');
  const [delegaciones, setDelegaciones] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen ?? '',
    month: moment().format('M'),
    year: moment().format('yy'),
    txtFiltro: ''
  }, `AdminConexionesFilter`);

  const months = [
  { id: 1, displayName: 'Enero' },
  { id: 2, displayName: 'Febrero' },
  { id: 3, displayName: 'Marzo' },
  { id: 4, displayName: 'Abril' },
  { id: 5, displayName: 'Mayo' },
  { id: 6, displayName: 'Junio' },
  { id: 7, displayName: 'Julio' },
  { id: 8, displayName: 'Agosto' },
  { id: 9, displayName: 'Septiembre' },
  { id: 10, displayName: 'Octubre' },
  { id: 11, displayName: 'Noviembre' },
  { id: 12, displayName: 'Diciembre' }];


  const years = [
  { id: 2026, displayName: '2026' },
  { id: 2025, displayName: '2025' },
  { id: 2024, displayName: '2024' },
  { id: 2023, displayName: '2023' },
  { id: 2022, displayName: '2022' },
  { id: 2021, displayName: '2021' },
  { id: 2020, displayName: '2020' },
  { id: 2019, displayName: '2019' },
  { id: 2018, displayName: '2018' }
];

  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setDelegaciones(adaptDelegacionArray(dataDelegaciones));
    getDelegacionOrigen({variables: { idUsuario: JSON.parse(storageId, 10) }});
  }, [dataDelegaciones]);

  const [getDelegacionOrigen, { data: dataDelegacionOrigen }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionOrigen) return;
    if (dataDelegacionOrigen.usuarioFull.success) {
      const deleg = parseInt(dataDelegacionOrigen.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);
      if (!(filters?.idDelegacion > 0))
        handleChangeFilters('idDelegacion', deleg);
    }
  }, [dataDelegacionOrigen]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({variables: { idUsuario: JSON.parse(storageId, 10) }});
    }    
  }, []);

  const applyTextFilter = (data, textFilter) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "") return data;

    const dataFiltered = data.filter((conexion) => {
      const hc = conexion?.hc?.toString().toUpperCase() || "";
      const contrato = conexion?.contrato?.toString().toUpperCase() || "";
      const codSAP = conexion?.codSAP?.toString().toUpperCase() || "";
      const nombrePaciente = conexion?.nombrePaciente?.toString().toUpperCase() || "";

      return (
        hc.includes(inputBuscar) ||
        contrato.includes(inputBuscar) ||
        codSAP.includes(inputBuscar) ||
        nombrePaciente.includes(inputBuscar));

    });

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter) => {
    const dataFilteredByText = applyTextFilter(data, textFilter);

    // sientase libre de agregar otra funcion de filtro y reemplazar la constante retornada
    return dataFilteredByText;
  };

  return {
    delegaciones,
    delegacionOrigen,
    months,
    years,
    filters,
    handleChangeFilters,
    delegacionesLoading,
    applyTextFilter,
    applyClientSideFilters
  };
};